import { createSelector } from 'reselect';

export const selectUsersList = (state) => state?.usersList;

export const selectUserListData = createSelector(selectUsersList, (state) => state);

export const selectUserDetail = createSelector(selectUsersList, (state) => state.userDetail);

export const selectFetchedProfilePictureId = createSelector(
  selectUsersList,
  (state) => state.fetchedProfilePictureId
);

export const selectHasUpdated = createSelector(selectUsersList, (state) => state.hasUpdated);

export const selectUpdateUserIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isUpdateProcessing
);

export const selectUpdateUserNameIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isUpdateUserNameProcessing
);

export const selectUpdateUserPhoneNumberIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isUpdateUserPhoneNumberProcessing
);

export const selectUpdateUserAddressIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isUpdateUserAddressProcessing
);

export const selectWorkerPlacements = createSelector(
  selectUsersList,
  (state) => state.workerPlacements
);

export const selectReliabilityExclusionPlacementId = createSelector(
  selectUsersList,
  (state) => state.reliabilityExclusionPlacementId
);

export const selectIsLoadingWorkerPlacements = createSelector(
  selectUsersList,
  (state) => state.isLoadingWorkerPlacements
);
export const selectIsUserDetailLoading = createSelector(
  selectUsersList,
  (state) => state.isUserDetailLoading
);
export const selectPendingWorkerPlacements = createSelector(
  selectUsersList,
  (state) => state.pendingWorkerPlacements
);

export const selectIsLoadingPendingWorkerPlacements = createSelector(
  selectUsersList,
  (state) => state.isLoadingPendingWorkerPlacements
);
export const selectPendingOffers = createSelector(selectUsersList, (state) => state.pendingOffers);

export const selectIsLoadingPendingOffers = createSelector(
  selectUsersList,
  (state) => state.isLoadingPendingOffers
);

export const selectWorkerContracts = createSelector(
  selectUsersList,
  (state) => state.workerContracts
);

export const selectIsLoadingWorkerContracts = createSelector(
  selectUsersList,
  (state) => state.isLoadingWorkerContracts
);

export const selectEmployeeDocumentation = createSelector(
  selectUsersList,
  (state) => state.employeeDocumentation
);

export const selectIsLoadingEmployeeDocumentation = createSelector(
  selectUsersList,
  (state) => state.isLoadingEmployeeDocumentation
);

export const selectHasEmployeeDocumentationError = createSelector(
  selectUsersList,
  (state) => state.hasEmployeeDocumentationError
);

export const selectOnboardingDocuments = createSelector(
  selectUsersList,
  (state) => state.onboardingDocuments
);

export const selectIsLoadingOnboardingDocuments = createSelector(
  selectUsersList,
  (state) => state.isLoadingOnboardingDocuments
);

export const selectHasOnboardingDocumentsError = createSelector(
  selectUsersList,
  (state) => state.hasOnboardingDocumentsError
);

export const selectIsProcessingUserStatusUpdate = createSelector(
  selectUsersList,
  (state) => state.isProcessingUserStatusUpdate
);

export const selectCertifications = createSelector(
  selectUsersList,
  (state) => state.certifications
);

export const selectCertificationsIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isLoadingCertifications
);

export const selectDNRData = createSelector(selectUsersList, (state) => state.DNRData);

export const selectDNRDataIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isLoadingUpdateDNR
);

export const selectDNAData = createSelector(selectUsersList, (state) => state.DNAData);

export const selectDNADataIsProcessing = createSelector(
  selectUsersList,
  (state) => state.isLoadingUpdateDNA
);

export const selectIsLoadingUsers = createSelector(
  selectUsersList,
  (state) => state.isUsersLoading
);

export const selectIsProcessingPostUser = createSelector(
  selectUsersList,
  (state) => state.isProcessingPostUser
);

export const selectPostUserError = createSelector(selectUsersList, (state) => state.postUserError);

export const selectTaxCreditOpportunities = createSelector(
  selectUsersList,
  (state) => state.taxCreditOpportunities
);

export const selectIsProcessingWotcEligibility = createSelector(
  selectUsersList,
  (state) => state.isProcessingWotcEligibility
);

export const selectIsProcessingUrbanYouthCertified = createSelector(
  selectUsersList,
  (state) => state.isProcessingUrbanYouthCertified
);

export const selectIsProcessingDocumentsApproved = createSelector(
  selectUsersList,
  (state) => state.isProcessingDocumentsApproved
);

export const selectIsProcessingEVerify = createSelector(
  selectUsersList,
  (state) => state.isProcessingEVerify
);

export const selectIsLoadingUserHistory = createSelector(
  selectUsersList,
  (state) => state.isLoadingUserHistory
);
